import * as React from 'react';
const { Tooltip } = require('react-tippy');
import 'react-tippy/dist/tippy.css';

interface Props {
	title?: string;
	html?: {};
	className?: string;
	children?: {};
}

const CustomTooltip: React.StatelessComponent<Props> = props => {
	return (
		<Tooltip
			title={props.title}
			html={props.html}
			className={props.className}
			animation="shift"
			animateFill={false}
			arrow={true}
			duration={175}
			delay={100}
		>
			{props.children}
		</Tooltip>
	);
};

export default CustomTooltip;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/Tooltip.tsx